module.exports = __webpack_public_path__ + "static/media/18.b09efe2e.jpg";